module.exports = __webpack_public_path__ + "assets/berlin-skyline-fallback.ead0b96f.png";